import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import SectionCurve from '../SectionCurve/SectionCurve';
import { scrollToSectionWithRetry } from '../../utils/scrollToSection';

const Layout: React.FC = () => {
  const { pathname, hash } = useLocation();
  const showFooterCurve = pathname === '/';

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return undefined;
    }

    const id = hash.replace('#', '');
    scrollToSectionWithRetry(id);
    return undefined;
  }, [pathname, hash]);

  return (
    <div className="App">
      <Navbar />
      <main>
        <Outlet />
      </main>
      {showFooterCurve && <SectionCurve from="contact" to="primary" hideBase overlap />}
      <Footer />
    </div>
  );
};

export default Layout;
